import { useState, useEffect } from "react";
import { Box, Button, CloseButton, Dialog, HStack, Portal, Text, VStack } from "@chakra-ui/react";
import LeadInterestLevelBadge from "../LeadInterestLevelBadge";

const INTEREST_LEVELS = ["Low", "Medium", "High"];

const ChangeLeadInterestLevelModal = ({ isOpen, onClose, currentInterestLevel, onSubmit, isLoading }) => {
    const [selectedLevel, setSelectedLevel] = useState(currentInterestLevel ?? null);

    useEffect(() => {
        if (isOpen) setSelectedLevel(currentInterestLevel ?? null);
    }, [isOpen, currentInterestLevel]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner p={4}>
                    <Dialog.Content
                        bg="white" color="gray.900" borderColor="gray.200" border="1px solid"
                        boxShadow="0 4px 24px rgba(23,21,31,0.12)"
                        w={{ base: "calc(100vw - 2rem)", md: "md" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                        overflowY="auto" borderRadius={12}
                    >
                        <Dialog.Body pt={6} pb={6} px={6}>
                            <Text fontWeight={700} fontSize="lg" color="gray.900" mb={4}>Zmień poziom zainteresowania</Text>
                            <VStack align="stretch" gap={2} mb={4}>
                                <Box
                                    as="button" onClick={() => setSelectedLevel(null)}
                                    display="flex" alignItems="center" gap={3} px={3} py={2} borderRadius={8}
                                    border="1px solid" borderColor={selectedLevel === null ? "purple.400" : "gray.200"}
                                    bg={selectedLevel === null ? "purple.50" : "white"}
                                    cursor="pointer" transition="all 0.15s" _hover={{ borderColor: "purple.400" }}
                                    outline="none" textAlign="left"
                                >
                                    <Text color="gray.500" fontSize="sm">Brak</Text>
                                </Box>
                                {INTEREST_LEVELS.map(level => (
                                    <Box
                                        key={level} as="button" onClick={() => setSelectedLevel(level)}
                                        display="flex" alignItems="center" gap={3} px={3} py={2} borderRadius={8}
                                        border="1px solid" borderColor={selectedLevel === level ? "purple.400" : "gray.200"}
                                        bg={selectedLevel === level ? "purple.50" : "white"}
                                        cursor="pointer" transition="all 0.15s" _hover={{ borderColor: "purple.400" }}
                                        outline="none" textAlign="left"
                                    >
                                        <LeadInterestLevelBadge interestLevel={level} />
                                    </Box>
                                ))}
                            </VStack>
                            <HStack justify="flex-end" gap={2}>
                                <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                                <Button variant="primary" size="sm" loading={isLoading} onClick={() => onSubmit(selectedLevel)}>
                                    Zapisz
                                </Button>
                            </HStack>
                        </Dialog.Body>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" position="absolute" top="2" right="2" color="gray.400" _hover={{ color: "gray.600", bg: "gray.100" }} />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default ChangeLeadInterestLevelModal;
